exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-color[data-v-2119d872]{background-color:var(--systemMainColor);color:var(--colorLumpText)}.el-popper.tag_select-popper .el-select-dropdown__item[data-v-2119d872]{height:100%!important;padding:0}", ""]);

// exports
